import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import SchedulingManagement from '@/types/table/schedulingManagement';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface SchedulingManagementData extends SchedulingManagement {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class SchedulingManagementController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SchedulingManagementData>>(API_CONTEXT + '/app/schedulingManagement/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<SchedulingManagementData>(API_CONTEXT + '/app/schedulingManagement/view', params, httpOptions);
  }
    static selectByHeandId(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<SchedulingManagementData>(API_CONTEXT + '/app/schedulingManagement/selectByHeandId', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/schedulingManagement/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/schedulingManagement/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/schedulingManagement/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingManagement/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingManagement/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingManagement/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingManagement/deleteBatch', params, httpOptions);
  }
  static addBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingManagement/addBatch', params, httpOptions);
  }

  static disabledBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingManagement/disabledBatch', params, httpOptions);
  }
  static deleteClearDisabled(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingManagement/deleteClearDisabled', params, httpOptions);
  }


}
